import { Language } from "./types"

export const appRoot = 'xplore_react_reservations_header'
// export const loadAttributes = () => {
//     const lang = (document.getElementsByClassName('xplore_react_reservations_header')[0] as HTMLElement).getAttribute('lang') as Language
    
//     // const lang = Language.CZ
//     return {lang}
    
// }

export function getHeaders() {
    // return { Authorization: 'Bearer ' + accessToken }
    let access_token = getAccessToken()
    let headers = {
        'x-access-token': access_token
    }
    return headers
}

export function getAccessToken() {
    let access_token = localStorage.getItem("xplore_token") || ""
    return access_token
}

export function removeAccessToken() {
    localStorage.removeItem("xplore_token")
}